/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import Filter, { FilterableProps } from '../Filter'
import { handleChangeEvent } from '../../../../client/js/lib/form'
import { Radio } from '@mantine/core'

function WithChargesFilter (props: FilterableProps) {
  const { onChange, value } = props
  const intl = useIntl()
  return (
    <Filter>
      <Radio
        checked={value == null}
        id="with_charges_all_filter"
        label={intl.formatMessage({
          id: 'all',
          defaultMessage: 'Tout'
        })}
        name="withCharges"
        onChange={handleChangeEvent(onChange)}
        value=""
      />
      <Radio
        checked={value === 'true'}
        id="with_charges_filter"
        label={intl.formatMessage({
          id: 'with_charges',
          defaultMessage: 'Avec charges'
        })}
        name="withCharges"
        onChange={handleChangeEvent(onChange)}
        value="true"
      />
      <Radio
        checked={value === 'false'}
        id="without_charges_filter"
        label={intl.formatMessage({
          id: 'without_charges',
          defaultMessage: 'Sans charges'
        })}
        name="withCharges"
        onChange={handleChangeEvent(onChange)}
        value="false"
      />
    </Filter>
  )
}

export default WithChargesFilter
